







































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Resolve } from 'vue-di';
import LayoutModule from '~/store/layout';
import { Settings } from '~/services/settings';

@Component<Footer>({})
export default class Footer extends Vue {
    @Resolve
    public layout!: LayoutModule;
    @Resolve
    public settings!: Settings;
    @Prop()
    public brkPoints!: object;
    @Prop({ default: false })
    public isFixed!: boolean;

    public windowWidth = 0;

    mounted() {
        this.layout.replaceProgramName(this.layout.configuration.programName, this.layout.previousProgramName);
        this.windowWidth = window.innerWidth;
        window.addEventListener('resize', this.handleResize);
        console.log('windowWidth', this.windowWidth);
    }

    public handleResize() {
        this.windowWidth = window.innerWidth;
    }

    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    }

    public get isMobile() {
    return this.windowWidth <= 768;
    }

    @Watch('layout.configuration.programName', { deep: true })
    public watchProgramName(programName: string) {
        this.layout.replaceProgramName(programName, this.layout.previousProgramName);
    }

    public get footerInfoLinkLocation() {
        return this.layout.configuration.footerInfoLinkLocation;
    }

    public get isTopOrBottomBar() {
        return ['top', 'bottom'].includes(this.footerInfoLinkLocation);
    }

    public get isLeftOrRightBar() {
        return ['left', 'right'].includes(this.footerInfoLinkLocation);
    }

    public get footerLogoSrc() {
        return this.layout.configuration.images.footer || this.$settings.url(this.$settings.footerLogo);
    }
    public get shouldShowSplashPage(): boolean {
        return this.settings.shouldShowSplashPage === 'true' || this.layout.shouldShowSplashPage;
    }

    // public get isMobile() {
    //     // return this.windowWidth <= 380;
    //     return this.windowWidth <= 768;
    // }

}
